import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ABOUT_PAGE_MODEL } from '@banyan/commons/consts/builder-io-model.const';
import { customComponents } from '@banyan/modules/builder-io/builder-registry';
import { BuilderService } from '@banyan/modules/builder-io/services/builder.service';
import { SeoMetaService } from '@banyan/modules/shared/services/seo-meta/seo-meta.service';
import { BuilderContent, Content } from '@builder.io/sdk-angular';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-who-we-are',
  standalone: true,
  imports: [Content, CommonModule],
  templateUrl: './who-we-are.component.html',
  styleUrls: ['./who-we-are.component.scss'],
})
export class WhoWeAreComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router);
  builderService = inject(BuilderService);
  translateService = inject(TranslateService);
  seoMetaService = inject(SeoMetaService);
  content: BuilderContent | null = null;
  apiKey = environment.builderIoApiKey;
  urlPath!: string;
  protected readonly customComponents = customComponents;

  ngOnInit() {
    this.translateService.onLangChange.subscribe(() => {
      this.refetch();
    });
    this.route.data.subscribe((data: any) => {
      this.urlPath = '/' + this.route.snapshot.url.map(s => s.path).join('/');
      this.content = data?.about;
      this.updateContent(data?.about.data);
    });
  }

  private updateContent(metadata: any) {
    const { pageTitle = '', description = '', keywords = '' } = metadata || {};
    this.seoMetaService.updateMetaData(pageTitle, description, keywords);
  }

  async refetch() {
    this.content = await this.builderService.fetchContent(this.urlPath, ABOUT_PAGE_MODEL);
    this.updateContent(this.content?.data);
  }

  protected readonly ABOUT_PAGE_MODEL = ABOUT_PAGE_MODEL;
}
